module.exports = __webpack_public_path__ + "static/media/play-for-poltys.b14b3269.png";